<template>
    <uploadList uploadType="img" uploadTitle="点击上传本地图片" btnTitle="预览" :accept="['.jpg','.png','.jpeg']" listW="180px" listH="290px" :rowNum="5" :limit="14" uploadSize="5mb"></uploadList>
</template>
<script>
import uploadList from '../../components/uploadList/index.vue'
export default {
    data() {
        return {
            searchObj: {

            }
        }
    },
    components: {
        uploadList
    }
}
</script>
<style lang="less" scoped>

</style>